import styled, { css } from 'styled-components';
import { StyledImageThumbnailProps } from './ImageThumbnail.types';

export const StyledImageThumbnail = styled.div<StyledImageThumbnailProps>`
  position: relative;

  .image-thumbnail__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${({ imageBackgroundSize }) => {
      return css`
        background-size: ${imageBackgroundSize};
      `;
    }}
    background-repeat: no-repeat;
  }

  ${(props) => props.customStyle}
`;
